/* Gooseket detail.js — guarded revision of supplied English storefront file.
 * Keep Swiper loaded before this deferred script. Test in an unpublished theme first.
 */
(() => {
  'use strict';
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };
  const hasSwiper = () => typeof window.Swiper === 'function';
  const initSwiper = (element, options) => {
    if (!element || !hasSwiper()) return null;
    if (element.swiper && !element.swiper.destroyed) return element.swiper;
    return new window.Swiper(element, options);
  };
  const setProgress = (bar, current, total) => {
    if (bar && total > 0) bar.style.width = `${Math.min(100, Math.max(0, current / total * 100))}%`;
  };
  const getSlides = (instance) => instance && instance.slides ? instance.slides.length : 0;
  const setImage = (image, src) => { if (image && src) image.src = src; };
  const playSafely = (video) => { try { const promise = video.play(); if (promise && promise.catch) promise.catch(() => {}); } catch (_) {} };

  ready(() => {
    // 1. 365 Plus color slides. Scope chips to this particular slider when possible.
    const slideContainer = document.getElementById('slideContainer');
    const progressBar = document.getElementById('progressBar');
    const selectedColorDisplay = document.getElementById('selectedColor');
    const sliderRoot = slideContainer && slideContainer.closest('.swiper');
    const colorMap = {
      beige: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-beige.jpg)', name: ' ベージュ' },
      gray: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-gray.jpg)', name: ' グレー' },
      mint: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-mint.jpg)', name: ' ミント' },
      khaki: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-khaki.jpg)', name: ' カーキ' },
      bk: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/anayo-black.jpg)', name: ' ブラック' },
      zebra: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/zebra_2c186bb6-337e-4276-900f-32f1196e5ce5.jpg)', name: ' ゼブラ' },
      bleo: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/brown-leopard_d51a4ff1-4eeb-41ce-8ebe-fc425132fab7.jpg)', name: ' ブラウンレオパード' },
      gleo: { bg: 'url(https://cdn.shopify.com/s/files/1/0485/0486/4929/files/gray-leopard_dabcaa90-d935-4442-89f1-781b4c9ec972.jpg)', name: ' グレー レオパード' }
    };
    if (slideContainer && sliderRoot && hasSwiper()) {
      let swiper = null;
      const loadSlides = (color) => {
        if (!colorMap[color]) return;
        if (swiper && !swiper.destroyed) swiper.destroy(true, true);
        slideContainer.replaceChildren();
        for (let i = 1; i <= 6; i++) {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          const img = document.createElement('img');
          img.src = `https://gooseket.com/web/upload/product_detail/365plus/colorchip/365plus_${color}${String(i).padStart(2, '0')}.jpg`;
          img.alt = `${color}-${i}`;
          slide.appendChild(img);
          slideContainer.appendChild(slide);
        }
        swiper = new window.Swiper(sliderRoot, {
          loop: false, slidesPerView: 1.5, spaceBetween: 10, grabCursor: true, allowTouchMove: true,
          on: { slideChange() { setProgress(progressBar, this.realIndex + 1, getSlides(this)); } }
        });
        setProgress(progressBar, 1, 6);
      };
      const colorChips = [...document.querySelectorAll('.color-circle[data-color]')]
        .filter(chip => !!colorMap[chip.dataset.color] && !chip.hasAttribute('data-img'));
      colorChips.forEach(chip => {
        const info = colorMap[chip.dataset.color];
        chip.style.backgroundImage = info.bg;
        chip.style.backgroundSize = 'cover';
        chip.style.backgroundPosition = 'center';
        chip.addEventListener('click', () => {
          colorChips.forEach(c => c.classList.remove('active'));
          chip.classList.add('active');
          loadSlides(chip.dataset.color);
          if (selectedColorDisplay) {
            selectedColorDisplay.replaceChildren();
            const swatch = document.createElement('div');
            swatch.className = 'chip';
            swatch.style.backgroundImage = info.bg;
            swatch.style.backgroundSize = 'cover';
            const name = document.createElement('span');
            name.textContent = info.name;
            selectedColorDisplay.append(swatch, name);
          }
        });
      });
      loadSlides('bk');
    }

    // 2. Structure slider.
    document.querySelectorAll('.structure-swiper').forEach(el => initSwiper(el, {
      slidesPerView: 1.5, spaceBetween: 20, grabCursor: true,
      loop: false, centeredSlides: false, slidesOffsetAfter: 40
    }));

    // 3. Single image sliders with progress indicators.
    const initSingleSlider = (selector, barSelector) => {
      document.querySelectorAll(selector).forEach(el => {
        const bar = document.querySelector(barSelector);
        const update = instance => setProgress(bar, instance.activeIndex + 1, getSlides(instance));
        const instance = initSwiper(el, {
          slidesPerView: 1, loop: false, spaceBetween: 10, grabCursor: true,
          on: { init() { update(this); }, slideChange() { update(this); } }
        });
        if (instance) update(instance);
      });
    };
    initSingleSlider('.customSingleSlideSwiper', '#customProgressBar');
    initSingleSlider('.customSingleSlideSwiper2', '#progressBarSliderOnly');

    // 4. Sling bag image swatches. Only chips with data-img belong to this feature.
    const image = document.getElementById('mainImage');
    if (image) {
      const chips = [...document.querySelectorAll('.color-circle[data-img]')];
      const chipDisplay = document.querySelector('#selectedColor .chip');
      const nameDisplay = document.querySelector('#selectedColor span');
      chips.forEach(chip => chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
        setImage(image, chip.dataset.img);
        if (chipDisplay && chip.dataset.hex) chipDisplay.style.background = chip.dataset.hex;
        if (nameDisplay) nameDisplay.textContent = chip.dataset.name || '';
      }));
    }
    const imageTop = document.getElementById('mainImageTop');
    if (imageTop) {
      const chips = [...document.querySelectorAll('.color-circle-top')];
      const chipDisplay = document.querySelector('#selectedColorTop .chip-top');
      const nameDisplay = document.querySelector('#selectedColorTop span');
      chips.forEach(chip => chip.addEventListener('click', () => {
        chips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
        setImage(imageTop, chip.dataset.img);
        if (chipDisplay && chip.dataset.hex) chipDisplay.style.background = chip.dataset.hex;
        if (nameDisplay) nameDisplay.textContent = chip.dataset.name || '';
      }));
    }

    // 5. 365 hip carrier color-specific wearing-photo sliders.
    const colorSliderElements = [...document.querySelectorAll('.swiper.colorSwiper[data-color]')]
      .filter(el => el !== sliderRoot);
    if (colorSliderElements.length && hasSwiper()) {
      const instances = new Map();
      colorSliderElements.forEach(el => {
        const color = el.dataset.color;
        const bar = [...document.querySelectorAll('.progress-bar-container[data-color]')]
          .find(item => item.dataset.color === color)?.querySelector('.progress-bar-fill');
        const update = instance => setProgress(bar, instance.activeIndex, Math.max(1, getSlides(instance) - 1));
        const instance = initSwiper(el, {
          slidesPerView: 1.5, spaceBetween: 10, centeredSlides: false,
          on: { slideChange() { update(this); }, init() { update(this); } }
        });
        if (instance) instances.set(color, instance);
      });
      const chips = [...document.querySelectorAll('.color-chip[data-color]')];
      const selectColor = color => {
        chips.forEach(chip => chip.classList.toggle('active', chip.dataset.color === color));
        const label = document.querySelector('.color_slide_365-label');
        if (label) label.textContent = color;
        colorSliderElements.forEach(el => { el.style.display = el.dataset.color === color ? 'block' : 'none'; });
        document.querySelectorAll('.progress-bar-container[data-color]').forEach(bar => {
          bar.style.display = bar.dataset.color === color ? 'block' : 'none';
        });
        const instance = instances.get(color);
        if (instance) { instance.update(); instance.slideTo(0); }
      };
      chips.forEach(chip => chip.addEventListener('click', () => selectColor(chip.dataset.color)));
      if (chips.length) selectColor(chips[0].dataset.color);
    }

    // 6. Existing .accordion behavior. Does not alter HOW TO USE markup.
    document.querySelectorAll('.accordion').forEach(header => {
      const panel = header.nextElementSibling;
      if (!panel) return;
      header.addEventListener('click', () => {
        header.classList.toggle('active');
        panel.style.maxHeight = panel.style.maxHeight ? '' : `${panel.scrollHeight}px`;
      });
    });

    // 7. Product description videos: play when visible, including top-level videos.
    const videoRoots = document.querySelectorAll('.product__description, #prdDetailWrapAll_new, .rte');
    const videos = [...new Set([...videoRoots].flatMap(root => [...root.querySelectorAll('video')]))];
    if (videos.length) {
      const START = 0.15;
      const STOP = 0.01;
      const state = new WeakMap();
      videos.forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        if (video.getAttribute('preload') === 'none') video.preload = 'metadata';
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const video = entry.target;
            const visible = entry.isIntersecting && entry.intersectionRatio >= START;
            if (visible && !document.hidden) {
              if (video.paused) playSafely(video);
              state.set(video, true);
            } else if (!entry.isIntersecting || entry.intersectionRatio <= STOP) {
              if (!video.paused) video.pause();
              state.set(video, false);
            }
          });
        }, { threshold: [0, STOP, START, 1] });
        videos.forEach(video => observer.observe(video));
      } else {
        videos.forEach(video => { if (video.autoplay) playSafely(video); });
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) return;
        videos.forEach(video => {
          const r = video.getBoundingClientRect();
          if (r.height && r.bottom > 0 && r.top < window.innerHeight && video.paused) playSafely(video);
        });
      });
    }

    // 8. Winter warmer and windbreaker intro slider: initialize ONCE.
    document.querySelectorAll('.introSwiper').forEach(el => {
      const update = instance => {
        const current = instance.activeIndex + 1;
        const total = getSlides(instance);
        setProgress(document.getElementById('introProgressBar'), current, total);
        setProgress(document.querySelector('.intro-progress-bar'), current, total);
      };
      const instance = initSwiper(el, {
        slidesPerView: 1, loop: false, spaceBetween: 10, grabCursor: true,
        on: { init() { update(this); }, slideChange() { update(this); } }
      });
      if (instance) update(instance);
    });

    // 9. Windbreaker warmer bottom color gallery.
    document.querySelectorAll('.color_slide_365-wrap').forEach(container => {
      if (!hasSwiper()) return;
      const instances = new Map();
      const sliders = [...container.querySelectorAll('.color_slide_365-swiper')];
      sliders.forEach(el => {
        const color = el.dataset.color;
        const progress = el.nextElementSibling?.querySelector('.color_slide_365-progress-fill');
        const update = instance => setProgress(progress, instance.activeIndex, Math.max(1, getSlides(instance) - 1));
        const instance = initSwiper(el, {
          slidesPerView: 1.5, spaceBetween: 10, centeredSlides: false,
          on: { slideChange() { update(this); }, init() { update(this); } }
        });
        if (instance) instances.set(color, instance);
      });
      const chips = [...container.querySelectorAll('.color_slide_365-chip')];
      const selectColor = color => {
        chips.forEach(chip => chip.classList.toggle('active', chip.dataset.color === color));
        sliders.forEach(el => { el.style.display = el.dataset.color === color ? 'block' : 'none'; });
        container.querySelectorAll('.color_slide_365-progress').forEach(progress => {
          progress.style.display = progress.previousElementSibling?.dataset.color === color ? 'block' : 'none';
        });
        const instance = instances.get(color);
        if (instance) { instance.update(); instance.slideTo(0); }
        const label = container.querySelector('.color_slide_365-label');
        if (label) label.textContent = color;
      };
      chips.forEach(chip => chip.addEventListener('click', () => selectColor(chip.dataset.color)));
      if (chips.length) selectColor(chips[0].dataset.color);
    });

    // 10. AIR sling bag sliders.
    document.querySelectorAll('.airBagSwiper').forEach(el => initSwiper(el, {
      loop: true, slidesPerView: 1, spaceBetween: 0,
      pagination: { el: el.closest('.swiper')?.parentElement?.querySelector('.airBagPagination') || '.airBagPagination', clickable: true }
    }));
    document.querySelectorAll('.airUseSwiper').forEach(el => initSwiper(el, {
      loop: false, slidesPerView: 'auto', spaceBetween: 10, grabCursor: true,
      pagination: { el: el.closest('.swiper')?.parentElement?.querySelector('.airUsePagination') || '.airUsePagination', type: 'progressbar' }
    }));
  });
})();
